import { render } from "./merchant_contact_footer.vue?vue&type=template&id=bd125736"
import script from "./merchant_contact_footer.vue?vue&type=script&lang=js"
export * from "./merchant_contact_footer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__